import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Lg from '../clientviews/telemedecine/image/LG1.png';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import "../new/docteur.css";
import l from '../../assets/images/timer-pause.svg';
import l1 from '../../assets/images/woman.svg';
import l2 from '../../assets/images/book-square.svg';
import l3 from '../../assets/images/microphone-2.png';
import Block from '../new/block1';
import Block1 from '../new/block2';
import Block2 from '../new/block3';
import BlockD from '../new/block d';
import Add from './addquestion';
import Allergie from '../new/allergie';
import Analyses from '../new/analyses';
import History from '../new/history';
import Clinical from '../new/clinical';
import Diagnosis from '../new/diagnosis';
import Medical from '../new/medical';
import Medicament from '../new/medicament';
import Laboratory from '../new/laboratoire';
import Recommendation from '../new/recommandation';
import Hospitalisation from '../new/hospitalisation';
import ServiceSelection from './service';
import Follow from '../new/follow';
import Frame from '../../assets/images/Frame.svg';
import Frame1 from '../../assets/images/Frame1.png';
import Ai from '../new/ai';
import api from '../../service/caller';
import Select from 'react-select';
import InvoiceModal from './invoicemodal';

const Docteur = () => {
  const navigate = useNavigate();
  const [UserData, setUserData] = useState([]);
  const [isSlidingPageOpen, setIsSlidingPageOpen] = useState(false);
  const [vitalSignsData, setVitalSignsData] = useState([]);
  const [hospitalId, sethospitalId] = useState([]);
  const [appointmentData, setappointmentData] = useState([]);
  const [error, setError] = useState(null); // Gestion des erreurs
  const [services, setServices] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
    const [DoctorData, setDoctorData] = useState([]);  
    const [ConsultationData, setConsultationData] = useState([]);


  const [formData, setFormData] = useState({
    doctor_questions: [
      { label: 'What are your symptoms?', content: 'Feeling pain in my lower back for several days now.' },
      { label: 'Did you take any self medication?', content: 'No' }
    ],
    allergies: [],
    medical_history: [],
    laboratory: [],
    doctor_prescription: [],
    clinical_exam: [],
    diagnosis: [],
    nonPharmacologicalrecommend: [],
    followUp: '',
    hospitalisation: [],
    services: [],
  });
  const [patientData, setPatientData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);


  const toggleSlidingPage = () => {
    setIsSlidingPageOpen(!isSlidingPageOpen); // Change l'état d'ouverture/fermeture
  };

  // Exemple d'utilisation avec un textarea (par défaut)
  const handleSymptomChange = (newContent) => {
    console.log("Symptoms updated:", newContent);
    // Vous pouvez mettre à jour votre état ici
  };

  // Exemple d'utilisation avec un input de type date
  const handleDateChange = (newDate) => {
    console.log("Date updated:", newDate);
  };

  const [isRecording, setIsRecording] = useState(false);
  const [audioURL, setAudioURL] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const startRecording = () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
          mediaRecorderRef.current = new MediaRecorder(stream);
          mediaRecorderRef.current.ondataavailable = event => {
            audioChunksRef.current.push(event.data);
          };

          mediaRecorderRef.current.onstop = () => {
            const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/wav' });
            const audioURL = URL.createObjectURL(audioBlob);
            setAudioURL(audioURL);
            audioChunksRef.current = [];  // Reset for next recording
          };

          mediaRecorderRef.current.start();
          setIsRecording(true);
        })
        .catch(error => {
          console.error('Error accessing microphone:', error);
        });
    } else {
      console.error('MediaRecorder API not supported in this browser.');
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  };

  // add question
  const [blocks, setBlocks] = useState([]); // Liste des blocs à afficher

  // Ajouter un nouveau bloc (question)
  const handleAddBlock = () => {
    setFormData(prevFormData => ({
      ...prevFormData,
      doctor_questions: [
        ...prevFormData.doctor_questions,
        { label: 'New question', content: '' }
      ]
    }));
  };

  // Fonction pour gérer les changements dans le contenu des blocs
  const handleContentChange = (index, newContent) => {
    setFormData(prevFormData => {
      const updatedQuestions = [...prevFormData.doctor_questions];
      updatedQuestions[index].content = newContent;
      return { ...prevFormData, doctor_questions: updatedQuestions };
    });
  };

  // Fonction pour gérer les changements du label
  const handleLabelChange = (index, newLabel) => {
    setFormData(prevFormData => {
      const updatedQuestions = [...prevFormData.doctor_questions];
      updatedQuestions[index].label = newLabel;
      return { ...prevFormData, doctor_questions: updatedQuestions };
    });
  };

  // Fonction pour gérer les changements dans le contenu des allergies
  const handleAllergieChange = (updatedAllergies) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      allergies: updatedAllergies,
    }));
  };

  // Fonction pour gérer les changements dans le contenu des history
  const handleHistoryChange = (updatedHistories) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      medical_history: updatedHistories,
    }));
  };

  // Fonction pour gérer les changements dans le contenu des clinical_exam
  const handleClinicChange = (updatedClinics) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      clinical_exam: updatedClinics,
    }));
  };

  // Fonction pour gérer les changements dans le contenu des clinical_exam
  const handleDiagnosisChange = (newDiagnosis, type) => {
    setFormData((prevData) => ({
      ...prevData,
      diagnosis: [
        ...prevData.diagnosis.filter((diag) => diag.type !== type),
        { type, content: newDiagnosis }
      ]
    }));
  };

  const handlePrescriptionsChange = (newPrescriptions) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      doctor_prescription: newPrescriptions
    }));
  };

  const handleSave = (newAnalysis) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      laboratory: newAnalysis // Met à jour uniquement les prescriptions
    }));
  };

  // Fonction qui met à jour les recommandations
  const handlerecommendChange = (newPharmacologicalrecommend) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      nonPharmacologicalrecommend: newPharmacologicalrecommend,
    }));
  };

  const handleFollowUpDateChange = (newfollowUp) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      followUp: newfollowUp,
    }));
  };

  const handleHospitalisationFormSubmit = (newHospitalisationData) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      hospitalisation: newHospitalisationData,
    }));
  };

  // Fonction pour mettre à jour les services sélectionnés dans formData
  const handleServicesChange = (selectedServices) => {
    // Mettre à jour les services dans formData
    const updatedFormData = { ...formData, services: selectedServices };
    setFormData(updatedFormData);
  };

  // recuperer les infos
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [consultationId, setConsultationId] = useState("")
  const patientId = queryParams.get('patient_id');
  const appointmentId = queryParams.get('appointmentId');

  // les information de l'utilisateur
  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const token = localStorage.getItem('access_token');
        if (!token) {
          throw new Error('Token not found');
        }

        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        toast.error("Failed to fetch data");
      }
    };
    fetchLoggedUserData();
  }, []);

  // patientdata 
  const fetchPatientData = async () => {
    try {
      const response = await api.get(`/clinic/getpatient/${patientId}`);
      setPatientData(response.data);
      console.log('Patient data loaded:', response.data);
    } catch (error) {
      console.error('Erreur lors de la récupération des données du patient:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPatientData();
  }, [patientId]);



  const fetchAvailableAppointments = async () => {
    try {
      const response = await api.get(`/clinic/getappointment/${appointmentId}`);
      setappointmentData(response.data.appointment);
    } catch (error) {
      console.error(error.message);
      setError('Erreur lors de la récupération des données du rendez-vous');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (appointmentId) {
      fetchAvailableAppointments();
    }
  }, [appointmentId]);

  // Fonction pour générer la facture et afficher le modal
  const generateInvoiceAndShowModal = () => {
    const invoice = generateInvoice(formData.services);
    // creer le billing

    setInvoiceData(invoice); // Enregistrer la facture générée dans l'état
    setShowInvoiceModal(true); // Afficher le modal
  };

  const closeModal = () => {
    setShowInvoiceModal(false); // Fermer le modal
  };

  const generateInvoice = (services) => {
    const totalPrice = services.reduce((acc, service) => {
      return acc + (parseFloat(service.price) * (service.quantity || 1)); // Calcul du total
    }, 0);

    const invoice = {
      services: services.map(service => ({
        name: service.name,
        price: parseFloat(service.price),
        quantity: service.quantity || 1,
        total: (parseFloat(service.price) * (service.quantity || 1)).toFixed(2), // Prix total pour chaque service
      })),
      totalPrice: totalPrice.toFixed(2), // Le total général de la facture
    };

    return invoice;
  };

  const generatePDF = async () => {
    try {
      const content = document.querySelector('.ordonnance-container');
      
      // Sauvegarde les styles originaux
      const originalStyle = content.getAttribute('style');
  
      // Rendre visible la div même si elle est cachée
      content.style.display = 'block';
      content.style.position = 'absolute';
      content.style.left = '-9999px'; // Loin de l’écran
      content.style.visibility = 'visible';
  
      // Capture avec html2canvas
      const canvas = await html2canvas(content, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff'
      });
  
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`ordonnance_${patientData?.name || 'patient'}.pdf`);
  
      // Restauration du style original
      if (originalStyle !== null) {
        content.setAttribute('style', originalStyle);
      } else {
        content.removeAttribute('style');
      }
  
    } catch (error) {
      toast.error("Erreur lors de la génération du PDF");
    }
  };
  


  const handleSubmit = async (e) => {

    // console.log('infosend',formData);
    e.preventDefault();

    const updatedFormData = {
      hospitalId: appointmentData.hospitalId,
      appointmentId: appointmentId,
      doctorId: UserData._id,
      patientId: patientId,
      otherdetails: formData.otherdetails || 'No details',
      medicalHistory: formData.medical_history,
      allergies: formData.allergies,
      diagnosis: formData.diagnosis,
      prescriptions: formData.doctor_prescription,
      followUp: formData.followUp,
      laboratoryAnalysis: formData.laboratory,
      doctorsquestion: formData.doctor_questions,
      nonPharmacologicalrecommend: formData.nonPharmacologicalrecommend,
      hospitalisation: formData.hospitalisation,
      clinical_exam: formData.clinical_exam,
      services: formData.services.map(service => ({
        serviceId: service.value,
        price: parseFloat(service.price),
        name: service.name
      }))
    };

    // console.log(updatedFormData);

    try {
      const response = await api.post('api/consultations', updatedFormData);
      if (response.status === 200 || response.status === 201) {
        const medicalHistoryData = {
          ConsultationId: response.data._id, // ConsultationId sera l'ID de la consultation créée
          AppointmentId: appointmentId,
          patientId: patientId,
          consultationDate: new Date(), // Date de la consultation
        };

        await api.post('clinic/addmedicalhistory', medicalHistoryData);

        // Maintenant, mettez à jour le statut de l'appointment à "Completed"
        await api.put(`/clinic/updateAppointmentStatus`, {
          appointmentId: appointmentId,
          status: 'Completed',
        });
        window.location.href = `/hospitaladmin/telemedecine/ordornance?consultationId=${response?.data?._id}&patientId=${patientId}`;
        toast.success("Consultation ended successfully!");
      } else {
        toast.error(response.data.message || "Failed to end consultation. Please try again.");

      }
    } catch (error) {
      toast.error(`Error: ${error?.response?.data?.message || 'An unexpected error occurred. Please try again.'}`);
      console.log('Error:', error?.response || 'No error message available.');
    }
  };

  useEffect(() => {
      // Charger les données du docteur une fois que les données de consultation sont disponibles
      const fetchDoctorData = async () => {
        if (ConsultationData?.doctorId) {
          try {
            const token = localStorage.getItem('access_token'); // ou depuis le state
  
            const response = await api.get(`api/users/${ConsultationData.doctorId}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            setDoctorData(response.data);
            console.log(response);
          } catch (error) {
            console.error('Erreur lors de la récupération des données du Docteur:', error);
          } finally {
            setLoading(false);
          }
        }
      };
  
      if (ConsultationData?.doctorId) {
        fetchDoctorData();
      }
    }, [ConsultationData]); // Dépendance sur ConsultationData
  
    const calculateAge = (birthDate) => {
      if (!birthDate) return ""; // Vérification si la date est vide
  
      const birth = new Date(birthDate);
      const today = new Date();
  
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      const dayDiff = today.getDate() - birth.getDate();
  
      // Si l'anniversaire n'est pas encore passé cette année, on enlève 1 an
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
          age--;
      }
  
      return age;
    };

  const age = patientData?.age ? calculateAge(patientData.age) : "";



  return (
    <div className="position-relative doctorconsultat p-3">
      <ToastContainer />
      <div className="row">
        <div className="col-lg-6 mx-auto mb-3">
          <div className="p-3 text-white" style={{ background: '#28A745', borderRadius: '20px' }}>
            <div className="d-flex justify-content-between">
              <div><p className="mt-2">Appointment with</p></div>
              <div>
                <img src={l} alt="timer" className="w-75 img-fluid" />
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div><h3>{`${patientData?.firstname} ${patientData?.lastname}`}</h3></div>
              <div>
                <p className="mt-2" style={{ fontSize: '13px' }}>00h : 00mn : 01s</p>
              </div>
            </div>
            <p style={{ fontSize: '13px' }}>started !</p>
          </div>
        </div>
        <div className="col-lg-6 mx-auto mb-3">
          <div className="p-3 text-white" style={{ background: '#FF9800', borderRadius: '20px' }}>
            <div className="d-flex justify-content-between">
              <div><p className="mt-2"> <strong>Gender :</strong> {patientData?.gender}</p></div>
              <div>
                <img src={l1} alt="timer" className="w-75 img-fluid" />
              </div>
            </div>
            <div><p> <strong>Birth Date: </strong> {patientData?.age ? new Date(patientData?.age).toISOString().split('T')[0] : ''}</p></div>
            <div>Starting time : {time.getHours()}h : {time.getMinutes()}mn : {time.getSeconds()}s</div>
          </div>
        </div>
      </div>
      <div className=" bg-white p-4">
        <div className="my-3">
          <button className="btn btn-primary">View medical history of patient <img src={l2} alt="timer" className="img-fluid" /></button>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-column">
            <div> <strong>Patient consent to recording ?</strong></div>
            <div className="d-flex">
              <div>
                <input type="radio" name="consent" className="form-check-input" id="consent1" />
                <label for="consent1" className="form-check-label" >Yes</label>
              </div>
              <div className="ms-4">
                <input type="radio" name="consent" className="form-check-input" id="consent2" />
                <label for="consent1" className="form-check-label" >No</label>
              </div>
            </div>
          </div>
          <div>
            <button
              className="btn btn-outline-success fw-bold"
              onClick={isRecording ? stopRecording : startRecording}
            >
              {isRecording ? 'Stop recording' : 'Start recording'}
              <img src={l3} alt="timer" className="img-fluid" />
            </button>

            {audioURL && (
              <audio controls>
                <source src={audioURL} type="audio/wav" />
                Your browser does not support the audio element.
              </audio>
            )}
          </div>
        </div>
        <div className="mb-5 mt-3 p-3" style={{ border: '1px dashed #0056B3', borderRadius: '10px' }}>

          <p className="p-2 text-center fw-bold" style={{ background: '#FF980017' }}>Registered vital signs</p>
          <p className="my-2 ms-4">Body Temperature :   <span style={{ color: '#EF3826' }}>35.7°C</span></p>
          <span className="d-block" style={{ borderBottom: '1px solid #292D3230' }}></span>
          <p className="my-2 ms-4">Blood pressure :     <span style={{ fontWeight: '600' }}>120/90 mmHg</span></p>
          <span className="d-block" style={{ borderBottom: '1px solid #292D3230' }}></span>
          <p className="my-2 ms-4">Note :    <span style={{ fontWeight: '600' }}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's </span></p>
          <span className="d-block" style={{ borderBottom: '1px solid #292D3230' }}></span>
        </div>

        <div >
          {/* Afficher les blocs ajoutés */}
          {formData.doctor_questions.map((item, index) => (
            <div key={index}>
              <Block
                initialLabel={item.label}
                initialContent={item.content}
                inputType={item.label === "Select appointment date" ? "date" : "text"}
                onContentChange={(newContent) => handleContentChange(index, newContent)}
                onLabelChange={(newLabel) => handleLabelChange(index, newLabel)}
              />
            </div>
          ))}


          <div className="d-flex justify-content-end">
            <button
              className="btn btn-prim"
              style={{ color: '#0056B3' }}
              onClick={handleAddBlock} // Lors du clic, ajouter un nouveau bloc
            >
              <i className="bi bi-plus-circle-fill me-2"></i>
              <span style={{ textDecoration: 'underline' }}>Add question</span>
            </button>
          </div>
        </div>

        <div className="mt-4">
          <div><Allergie onAllergieChange={handleAllergieChange} /></div>
        </div>
        <div className="mt-4">
          <div><History onHistoryChange={handleHistoryChange} /></div>
        </div>
        {/* <div className="mt-4">
          <div><Analyses /></div>
        </div> */}
        <div className="mt-4">
          <div><Clinical onClinicChange={handleClinicChange} /></div>
        </div>
        <div className="mt-4">
          <div><Diagnosis onDiagnosisChange={handleDiagnosisChange} /></div>

        </div>
        <div className="mt-4">
          <div><Medical /></div>
        </div>

        <div className="mt-4">
          <div><Medicament onPrescriptionsChange={handlePrescriptionsChange} /></div>
        </div>
        <div className="mt-2">
          <div><Laboratory onSave={handleSave} /></div>
        </div>

        <div className="mt-2">
          <div><Recommendation onRecommendChange={handlerecommendChange} /></div>
        </div>
        <div className="mt-2">
          <div><Hospitalisation onHospitalisationChange={handleHospitalisationFormSubmit} /></div>
        </div>
        <div className="mt-2">
          <div><ServiceSelection onServicesChange={handleServicesChange} /></div>
        </div>
        <div className="mt-2">
          <div><Follow onDateChange={handleFollowUpDateChange} /></div>
        </div>
        <div className="mt-2">
          <div className="d-flex ms-5">
            <div>
              <button className="btn btn-prim text-white" style={{ background: '#EF3826' }} onClick={handleSubmit}>End consultation <i class="bi bi-box-arrow-left ms-2"></i></button>
            </div>
            <div className="ms-5">
              <button className="btn btn-prim text-white" onClick={generatePDF} style={{ background: '#0056B3' }}>Generer l’ordonnance<i class="bi bi-box-arrow-up ms-2"></i></button>
            </div>
            <div className="ms-5">
              <button className="btn btn-success text-white" onClick={generateInvoiceAndShowModal}>
                Générer la Facture
                <i className="bi bi-box-arrow-up ms-2"></i>
              </button>
            </div>

            {/* Afficher le Modal si showInvoiceModal est vrai */}
            {showInvoiceModal && (
              <InvoiceModal
                showModal={showInvoiceModal} // Passer l'état du modal en prop
                invoiceData={invoiceData} // Passer les données de la facture en prop
                onClose={closeModal} // Passer la fonction de fermeture
              />
            )}
          </div>
        </div>

      </div>
      <div className="app-container">
        {/* Contenu principal */}
        <div className="bos">
          <a href="#" onClick={toggleSlidingPage}>
            <img src={Frame} className="img-fluid" />
          </a>
        </div>

        {/* Page coulissante */}
        <div className={`sliding-page ${isSlidingPageOpen ? "open" : ""}`}>
          <button className="close-btn btn btn-white" onClick={toggleSlidingPage}>
            <img src={Frame1} className="img-fluid" />
          </button>
          <div className="content" style={{ overflowY: 'auto' }}>
            <div><Ai /></div>
          </div>
        </div>
      </div>
      <div className="ordonnance-container position-relative maindiv" style={{display: "none"}}>
                          <div className="">
                            <div className="d-flex justify-content-between">
                              <div>
                                <img src={Lg} alt="logo" className="img-fluid w-100" />
                              </div>
                              <div className="text-end mt-2">
                                  <p style={{fontSize:'13px'}}><strong>CLINIQUE POLYVALENTE OLUWA SHEYI</strong></p>
                                  <p style={{fontSize:'13px',marginTop:'-.7rem'}}>06 B.P. 2102 COTONOU - </p>
                                  <p style={{fontSize:'13px',marginTop:'-.7rem'}}>CEL: (+229) 55 42 99 99 / 52 47 54 54</p>
                              </div>
                            </div>
                          </div>
                          <h5 className="text-center mt-3" style={{color:'#043972',fontSize:'14px'}}>MEDICAL PRESCRIBTION</h5>
                          <form className="row">
                            <div className="col-6 mx-auto mb-3">
                              <div className="d-flex mt-3 align-items-center">
                                <label 
                                  className="form-label me-2" 
                                  style={{ whiteSpace: 'nowrap',fontSize:'14px' }}
                                >
                                  Patient's name :
                                </label>
                                <input 
                                  type="text" 
                                  value={`${patientData?.firstname} ${patientData?.lastname}`}
                                  className="form-control"
                                  style={{ 
                                    border: 'none', 
                                    borderBottom: '1.5px solid #043972', 
                                    borderRadius: '0', 
                                    background: 'transparent',
                                    marginBottom:'2rem'
                                  }} 
                                />
                              </div>
                            </div>
                            <div className="col-6 mx-auto mb-3">
                              <div className="d-flex mt-3 align-items-center">
                                <label 
                                  className="form-label me-2" 
                                  style={{ whiteSpace: 'nowrap',fontSize:'14px' }}
                                >
                                  Date
                                </label>
                                <input 
                                  type="date" 
                                  // defaultValue={new Date().toISOString().split('T')[0]} // Définit la date du jour
                                  defaultValue={new Date().toISOString().split('T')[0]}
                                  className="form-control"
                                  style={{ 
                                    border: 'none', 
                                    borderBottom: '1.5px solid #043972', 
                                    borderRadius: '0', 
                                    background: 'transparent',
                                    marginBottom:'2rem' 
                                  }} 
                                />
                              </div>
                            </div>
                            <div className="col-6 mx-auto mb-3">
                              <div className="d-flex mt-3 align-items-center">
                                <label 
                                  className="form-label me-2" 
                                  style={{ whiteSpace: 'nowrap',fontSize:'14px' }}
                                >
                                  Date of birth :
                                </label>
                                <input 
                                  type="date" 
                                  value={patientData?.age ? new Date(patientData?.age).toISOString().split('T')[0] : ''}
                                  className="form-control"
                                  style={{ 
                                    border: 'none', 
                                    borderBottom: '1.5px solid #043972', 
                                    borderRadius: '0', 
                                    background: 'transparent',
                                    marginBottom:'2rem' 
                                  }} 
                                />
                              </div>
                            </div>
                            <div className="col-3 mx-auto mb-3">
                              <div className="d-flex mt-3 align-items-center">
                                <label 
                                  className="form-label me-2" 
                                  style={{ whiteSpace: 'nowrap',fontSize:'14px' }}
                                >
                                  Age :
                                </label>
                                <input 
                                  type="age" 
                                  value={age + ' years Old'}
                                  className="form-control"
                                  style={{ 
                                    border: 'none', 
                                    borderBottom: '1.5px solid #043972', 
                                    borderRadius: '0', 
                                    background: 'transparent',
                                    marginBottom:'2rem' 
                                  }} 
                                />
                              </div>
                            </div>
                            <div className="col-3 mx-auto mb-3">
                              <div className="d-flex mt-3 align-items-center">
                                <label 
                                  className="form-label me-2" 
                                  style={{ whiteSpace: 'nowrap',fontSize:'14px' }}
                                >
                                  Gender :
                                </label>
                                <input 
                                  type="text" 
                                  value={patientData?.gender}
                                  className="form-control"
                                  style={{ 
                                    border: 'none', 
                                    borderBottom: '1.5px solid #043972', 
                                    borderRadius: '0', 
                                    background: 'transparent',
                                    marginBottom:'2rem' 
                                  }} 
                                />
                              </div>
                            </div>
                          </form>
                          <div className="mt-4">
                            <div className="table-responsive">
                              <table className="table table-bordered" style={{fontSize:'14px'}}>
                                <thead>
                                  <tr style={{backgroundColor: 'rgba(248, 249, 250, 0.1) !important'}}>
                                    <th>N°</th>
                                    <th>Médicament</th>
                                    <th>Qté</th>
                                    <th>Posologie</th>
                                    <th>Période</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {formData.doctor_prescription?.map((prescription, index) => (
                                      <tr key={prescription._id}>
                                          <td>{index + 1} {/* Affiche l'indice + 1 pour numéroter les lignes */}</td> 
                                          <td>{prescription.name}</td>
                                          <td>{prescription.boxes}</td>
                                          <td>{prescription.dosage}</td>
                                          <td>{prescription.duration}</td>
                                      </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="mt-5 scurr1">
                            <div className="row">
                                <div className="col-8"></div>
                                <div className="col-4">
                                  <p className="text-center my-0">{UserData?.lastname + ' ' + UserData?.firstname}</p>
                                  {/* <p className="text-center my-0">{DoctorData?.role?.name}</p> */}
                                  
                                  <span className="d-block" style={{borderBottom:'2px solid #30B697'}}></span>
                                  <p className="text-center mt-2" style={{color:'#043972'}}>Doctor's Signature</p>
                                </div>
                            </div>
                          </div>
                          <br/>
                          <div className="mt-4 scurr">
                            <div className="px-5">
                                <p className="text-center" style={{fontSize:'14px',color:'#043972'}}>Prière de rapporter l'ordonnance à toute consultation ultérieure et prévenir 48h à l'avance pour annuler tout rendez-vous. Merci.</p>
                            </div>
                            <span className="d-block" style={{borderBottom:'4px solid #14AC89'}}></span>
                                <p className="text-center mt-3" style={{fontSize:'14px',color:'#043972'}}>
                                    06 B.P. 2102 COTONOU - CEL: (+229) 55 42 99 99 / 52 47 54 54
                                </p>
                                <p className="text-center mt-3" style={{fontSize:'14px',color:'#043972'}}>
                                    N° IFU 3202378655640 - RCCM RB/COT/23 B 34365 DU 26/01/2023
                                </p>
                          </div>
                      </div>
    </div>
  );
};

export default Docteur;
